import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to update units of measure for your products. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: '8XodpE',
    description: 'Product UOM Import help content text',
  },
  uploadFile: {
    id: '8cjYM6',
    defaultMessage: 'Upload File',
    description: 'Title for the first step of the import process',
  },
});
